<template lang="pug">
draggable.fb-cell(
    :class="{ 'is-empty': !list.length }"
    :data-empty-text="$t('Drop here')"
    :list="list"
    :group="{ name: 'fb-elements' }"
    :move="rejectContainers"
    :disabled="!edit"
    handle=".fb-handle"
    :animation="150"
    :options="{ forceFallback: true, fallbackOnBody: true, emptyInsertThreshold: 40 }"
    ghost-class="fb-ghost"
    drag-class="fb-drag"
    @change="$emit('change')"
    @end="$emit('change')"
)
    .fb-block(v-for="element in list" :key="element.id")
        form-builder-element(
            :element="element"
            :edit="edit"
            :selected="element.id === selectedId"
            :options="options"
            @select="$emit('select', $event)"
            @delete="$emit('delete', $event)"
            @change="$emit('change')"
        )
</template>

<i18n>
{
    "en": { "Drop here": "Drop field here" },
    "de": { "Drop here": "Feld hierher ziehen" }
}
</i18n>

<script>
import draggable from 'vuedraggable'
import FormBuilderElement from './FormBuilderElement'

export default {
    name: 'FormBuilderCell',
    components: { draggable, FormBuilderElement },
    props: {
        // a column's field array — mutated in place by vuedraggable
        list: { type: Array, default: () => [] },
        selectedId: { type: String, default: null },
        edit: { type: Boolean, default: true },
        options: { type: Object, default: () => ({}) },
    },
    methods: {
        // a "columns" container may never be dropped inside a cell (no nesting)
        rejectContainers(evt) {
            return evt.draggedContext.element.type !== 'columns'
        },
    },
}
</script>

<style lang="sass" scoped>
.fb-cell
    display: flex
    flex-direction: column
    gap: .5rem
    min-height: 90px
    padding: .5rem
    background: #fff
    border: 1px dashed #d3d7de
    border-radius: 6px
    &.is-empty
        align-items: center
        justify-content: center
        &::after
            content: attr(data-empty-text)
            color: #b4b9c2
            font-size: .78rem
            pointer-events: none
.fb-block
    width: 100%
.fb-ghost
    opacity: 1
    border: 1px dashed $--color-primary !important
    border-radius: 6px
    background: rgba($--color-primary, .08)
    ::v-deep > *
        visibility: hidden
.fb-drag
    opacity: .95
    box-shadow: 0 6px 16px rgba(0, 0, 0, .18)
    border-radius: 6px
</style>
